import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { ActionCreators } from "../../../redux/actions"

import ContentList from "../Bits/ContentList"

class EditAssets extends Component {
  componentDidMount() {
    const { getAssetList } = this.props
    getAssetList()
  }

  handleDeleteFormSubmit = (selectedItems) => {
    const { deleteItems } = this.props
    deleteItems("asset", selectedItems)
  }

  editItem = (item) => {
    const { editSingleItem } = this.props
    editSingleItem("asset", item)
  }

  addItem = () => {
    const { editSingleItem } = this.props
    editSingleItem("asset", { name: "" })
  }

  render() {
    const { assets } = this.props

    return (
      <div className="ManageContent__Content">
        <ContentList
          addItem={this.addItem}
          editItem={this.editItem}
          deleteItemsFunc={this.handleDeleteFormSubmit}
          header={"Edit assets"}
          items={assets}
        />
      </div>
    )
  }
}

EditAssets.propTypes = {
  editSingleItem: PropTypes.func,
  getAssetList: PropTypes.func,
  assets: PropTypes.array,
  deleteItems: PropTypes.func,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch)
}

function mapStateToProps(state) {
  return {
    assets: state.managecontent.assets,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditAssets)
